import { Entity } from './entities.model';
import { SportCategory } from './categories.model';

// tslint:disable: variable-name

export type MandatoryOptional = 'mandatory' | 'optional';
const DEFAULT_PATTERNS: LeagueConfigurations = {
  bid: {
    athletes: {
      entityValidation: 'mandatory',
      payment: 'mandatory'
    },
    contributors: {
      entityValidation: 'mandatory',
      payment: 'mandatory'
    }
  },
  championships: {
    scoresheet_visible_contributors: [],
    change_competitor_image: false,
    change_competitor_name: false,
    change_competitor_nickname: false,
  }
};

export interface LeagueConfigurationsBIDEntity {
  payment?: MandatoryOptional;
  entityValidation?: MandatoryOptional;
}
export class LeagueConfigurationBID {
  athletes?: LeagueConfigurationsBIDEntity;
  contributors?: LeagueConfigurationsBIDEntity;

  constructor(o: Partial<LeagueConfigurationBID>) {
    Object.assign(this, DEFAULT_PATTERNS.bid);
    if (o && o.athletes) {
      Object.assign(this.athletes, o.athletes);
    }
    if (o && o.contributors) {
      Object.assign(this.contributors, o.contributors);
    }
  }
}

export class LeagueChampionshipOptions {
  scoresheet_visible_contributors: number[];
  change_competitor_image: boolean;
  change_competitor_name:boolean;
  change_competitor_nickname:boolean;



  constructor(o: Partial<LeagueChampionshipOptions>) {
    Object.assign(this, DEFAULT_PATTERNS.championships);
    if (o) {
      Object.assign(this, o);
    }
  }
}
export class LeagueConfigurations {
  bid: LeagueConfigurationBID;
  championships: LeagueChampionshipOptions;

  constructor(o: LeagueConfigurations) {
    this.bid = new LeagueConfigurationBID(o && o.bid ? o.bid : undefined);
    this.championships = new LeagueChampionshipOptions(o?.championships);
  }
}

export class League extends Entity {
  sport_id: number;
  registration_opened_until: string;
  configurations: LeagueConfigurations;

  categories: SportCategory[];

  constructor(o: Partial<League>, normalize?: { int?: string[], dates?: string[] }) {
    super(o, normalize);
    this.configurations = new LeagueConfigurations(this.configurations);
  }
}
